import { AppState, Configs, LookAndFeel } from 'models/app';
import { UserCompany, CompanyDocTypeUserResponse } from 'models/response';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultProgramCode } from 'utils/constants';

export const initialState: AppState = {
  programCode: defaultProgramCode,
  programName: '',
  programUrl: '',
  config: {},
  companies: [],
  companiesDocTypeUser: [],
  style: {
    buildNumber: '',
    logo: '',
    headerText: '',
    headerColor: '',
    maintMsg: '',
    openIdUrl: '',
  },
  isMenuOpen: localStorage.getItem('app-menu') ? localStorage.getItem('app-menu') === 'open' : true,
  screenWidth: window.innerWidth,
  disabledDropdown: false,
  isHeaderExpanded: true,
};

export const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setConfigs: (state: AppState, { payload }: PayloadAction<Configs>) => {
      state.config = payload;
    },
    setCompanies: (state: AppState, { payload }: PayloadAction<UserCompany[]>) => {
      state.companies = payload;
    },
    setCompaniesDocTypeUser: (state: AppState, { payload }: PayloadAction<CompanyDocTypeUserResponse[]>) => {
      state.companiesDocTypeUser = payload;
    },
    setProgramCode: (state: AppState, { payload }: PayloadAction<number>) => {
      state.programCode = payload;
    },
    setProgramName: (state: AppState, { payload }: PayloadAction<string>) => {
      state.programName = payload;
    },
    setLookAndFeel: (state: AppState, { payload }: PayloadAction<LookAndFeel>) => {
      state.style = payload;
    },
    toggleMenu: (state: AppState) => {
      state.isMenuOpen = !state.isMenuOpen;
      localStorage.setItem('app-menu', state.isMenuOpen ? 'open' : 'closed');
    },
    setScreenWidth: (state: AppState, { payload }: PayloadAction<number>) => {
      state.screenWidth = payload;
    },
    setDisabledDropdown: (state: AppState, { payload }: PayloadAction<boolean>) => {
      state.disabledDropdown = payload;
    },
    setProgramUrl: (state: AppState, { payload }: PayloadAction<string>) => {
      state.programUrl = payload;
    },
    setHeaderExpanded: (state, action: PayloadAction<boolean>) => {
      state.isHeaderExpanded = action.payload;
    },
    toggleHeader: (state) => {
      state.isHeaderExpanded = !state.isHeaderExpanded;
    },
  },
});

export default slice.reducer;
